export default __webpack_public_path__ + "static/media/tete40.5bfbdb38.png";